"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _src = require("@seedlang/utils/src");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var SourceListWrapper = function SourceListWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "expanded", _descriptor, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "borderBottom",
      get: function get() {
        if (this.props.borderBottom) {
          return this.props.borderBottom;
        } else if (this.props.translate) {
          return '1px solid #e8e8e8';
        } else {
          return '1px solid #CCC';
        }
      }
    }, {
      key: "translations",
      get: function get() {
        var _this2 = this;
        if (this.props.translations) {
          var enTranslations = [];
          var userLanguageTranslation = [];
          this.props.translations.map(function (item) {
            var _item$source, _item$source2;
            if (item.source.text === _this2.props.preferredSource) {
              enTranslations.unshift(item);
            } else if ((_item$source = item.source) !== null && _item$source !== void 0 && _item$source.languageId.startsWith('EN')) {
              enTranslations.push(item);
            } else if (((_item$source2 = item.source) === null || _item$source2 === void 0 ? void 0 : _item$source2.languageId) !== 'U') {
              userLanguageTranslation.push(item);
            }
          });
          if (_state.AppUI.user.showNativeLanguageFirst) {
            return userLanguageTranslation.concat(enTranslations);
          } else {
            return enTranslations.concat(userLanguageTranslation);
          }
        }
        if (this.props.word && this.props.word.vocabSourceForUser) {
          return this.props.word.vocabSourceForUser(_state.AppUI.user);
        }
      }
    }, {
      key: "showMoreTranslationsButton",
      get: function get() {
        var _this$props$translati;
        return !this.expanded && (this.props.preview || (0, _src.isPresent)(this.props.preferredSource)) && ((_this$props$translati = this.props.translations) === null || _this$props$translati === void 0 ? void 0 : _this$props$translati.length) > this.props.numberPreviewSources;
      }
    }, {
      key: "expandSources",
      value: function expandSources() {
        this.expanded = true;
      }
    }, {
      key: "translationFontSize",
      value: function translationFontSize(translation) {
        if (translation.source.rightToLeftLanguage) {
          return (0, _utils.depixify)(this.props.fontSize) + 6;
        } else if (this.showMoreTranslationsButton) {
          return 30;
        }
        return this.props.fontSize;
      }
    }, {
      key: "translationLineHeight",
      value: function translationLineHeight(translation) {
        if (translation.source.rightToLeftLanguage) {
          return (0, _utils.depixify)(this.props.fontSize) + 8;
        } else if (translation.source.languageId === 'ZH' || translation.source.languageId === 'ZH2') {
          return (0, _utils.depixify)(this.props.fontSize) + 4;
        } else if (this.showMoreTranslationsButton) {
          return 30;
        }
        return this.props.fontSize;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          borderBottom: this.borderBottom,
          translations: this.translations,
          showMoreTranslationsButton: this.showMoreTranslationsButton,
          expandSources: this.expandSources,
          translationFontSize: this.translationFontSize,
          translationLineHeight: this.translationLineHeight
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "expanded", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "borderBottom", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "borderBottom"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "translations", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "translations"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showMoreTranslationsButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showMoreTranslationsButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "expandSources", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "expandSources"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "translationFontSize", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "translationFontSize"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "translationLineHeight", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "translationLineHeight"), _class2.prototype), _class2)) || _class;
};
SourceListWrapper.displayName = 'SourceListWrapper';
var _default = exports["default"] = SourceListWrapper;